import { ViewCard } from "./ViewCard";

/**
 * card which will fill horizontal space, using a side-by-side image/text at larger screens
 * and a stacked layout at smaller screens.
 */

export const ViewCardWide = ({
  imageComponent,
  largeImageSize = false,
  title,
  description,
}: {
  imageComponent: React.ReactNode;
  largeImageSize?: boolean;
  title: string;
  description: string;
}) => {
  return (
    <>
      {/* Small screens get stacked (vertical) layout */}
      <div className="tw:!block tw:md:!hidden tw:!h-auto tw:md:!h-full">
        <ViewCard
          imageComponent={imageComponent}
          title={title}
          description={description}
          orientation={"vertical"}
        />
      </div>

      {/* Large screens get side-by-side (horizontal) layout */}
      <div className="tw:!hidden tw:md:!block tw:!h-auto tw:md:!h-full">
        <ViewCard
          imageComponent={imageComponent}
          title={title}
          description={description}
          orientation={"horizontal"}
          largeImageSize={largeImageSize}
        />
      </div>
    </>
  );
};
